import type {MetaFunction} from "react-router";

export const meta: MetaFunction = () => {
    return [{title: "Intellsys OS"}];
};
